"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Microphone = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M10,20 L10,19 L12,19 L12.0003933,16.9776139 C9.19695546,16.7251845 7,14.3691554 7,11.5 L7,10 L8,10 L8,11.5 C8,13.9852814 10.0147186,16 12.5,16 C14.9142733,16 16.8844891,14.0987635 16.995102,11.7118357 L17,11.5 L17,10 L18,10 L18,11.5 C18,14.3688125 15.8035698,16.7246211 13.0006121,16.9775233 L13,19 L15,19 L15,20 L10,20 Z M12.5,4 C14.4329966,4 16,5.56700338 16,7.5 L16,11.5 C16,13.4329966 14.4329966,15 12.5,15 C10.5670034,15 9,13.4329966 9,11.5 L9,7.5 C9,5.56700338 10.5670034,4 12.5,4 Z M12.5,5 C11.1745166,5 10.0899613,6.03153594 10.0053177,7.33562431 L10,7.5 L10,11.5 C10,12.8807119 11.1192881,14 12.5,14 C13.8254834,14 14.9100387,12.9684641 14.9946823,11.6643757 L15,11.5 L15,7.5 C15,6.11928813 13.8807119,5 12.5,5 Z" })));
};
Microphone.displayName = 'Microphone';
exports.default = Microphone;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Microphone.js.map